import social1Svg from '@h2/assets/svg/illustrations/profiler/social1.svg'
import { earlyLessonImageMap } from '@h2/features/planning/components/earlyImages'

const LessonImage = ({ imageAlias }) => {
  return <img src={earlyLessonImageMap[imageAlias] || social1Svg} alt="lesson intro" />
}

export { LessonImage }
